import { Suspense } from 'react';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { GiftView } from '@modules/Gift/views/GiftView';


export const ReGift: React.FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <GiftView
          isRegift={true}
        />
      </Suspense>
    </ErrorBoundary>
  );
};